import * as React from 'react';
import { IAttendee } from '../../../../../Models/Attendees/IAttendee';
import { AddAttendeeRegistrationView } from './AddAttendeeRegistrationView';
import * as Services from '../../../../../Services/Services';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import { IEventApi } from '../../../../../Services/API/Event/IEventApi';
import { useBoolean } from '@fluentui/react-hooks';
import { ICreateRegistration } from '../../../../../Models/Registration/ICreateRegistration';
import { EventPriceTypeEnum } from '../../../../../Models/Event/EventPriceTypeEnum';
import { MessageBarType } from '@fluentui/react';

interface IAddAttendeeRegistrationProps {
    eventId: number;    
    isOpened: boolean;
    onDismiss: () => void;
    refresh?: (items?:number[]) => void;
}

export const AddAttendeeRegistration: React.FunctionComponent<IAddAttendeeRegistrationProps> = (props) => {

    const [isLoading, setIsLoading] = useBoolean(false);    
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()


    const addRegistrations = async (attendees: IAttendee[]) => {

        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const eventRegistrations: ICreateRegistration[] = attendees.map(item => {
            const data: ICreateRegistration = {
                attendantId: item.id,
                eventId: props.eventId,
                doprovod:"",
            }
            return data;
        });
        const result = await eventApi.createEventRegistration(props.eventId,eventRegistrations);
        if (result.isSuccess && result.data) {
            props.refresh && props.refresh(result.data);
            props.onDismiss();
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    return (<AddAttendeeRegistrationView
        addRegistrations={addRegistrations}
        isOpened={props.isOpened}
        onDismiss={props.onDismiss} />)
}
